<div class="mat-sidenav"
              [ngClass]="(sidenavExpanse | async) ? 'sidenav-aberto' : 'sidenav-fechado'">
  <div class="sidenav-base">
    <ng-container *ngIf="(sidenavExpanse | async)">
    </ng-container>

    <ng-container>
      <mat-list style="width: 100%; flex: 1; overflow-y: auto;">

        <div class="menu-container">
          <div class="menu-start">
            <!-- Configurações de Acesso (Grupo de Usuários) -->
            <a mat-list-item class="menu-item"
              *ngIf="showGrupoUsuario$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/grupo-usuario')"
              (click)="irParaUrl(GRUPO_USUARIO_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" *ngIf="(sidenavExpanse | async) === false">tune</mat-icon>
                <mat-icon class="mr-5" *ngIf="(sidenavExpanse | async)">tune</mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.ACCESS_SETTINGS' | translate }}</span>
              </span>
            </a>

            <!-- Sistema -->
            <a mat-list-item class="menu-item"
              *ngIf="showSistema$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/sistema')"
              (click)="irParaUrl(SISTEMA_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="alertas" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="alertas" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.SISTEMA' | translate }}</span>
              </span>
            </a>

            <!-- Indicadores -->
            <a mat-list-item class="menu-item"
              *ngIf="showIndicadores$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/indicadores')"
              (click)="irParaUrl(INDICADORES_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="chart" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="chart" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.INDICADORES' | translate }}</span>
              </span>
            </a>

            <!-- Tipos de Incidente -->
            <a mat-list-item class="menu-item"
              *ngIf="showIncidentes$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/incidentes')"
              (click)="irParaUrl(TIPOS_INCIDENTE_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="siren" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="siren" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.INCIDENTES' | translate }}</span>
              </span>
            </a>

            <!-- Layouts de Importação -->
            <a mat-list-item class="menu-item"
              *ngIf="showImportacao$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/importacao')"
              (click)="irParaUrl(LAYOUTS_IMPORTACAO_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="layout-grid" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="layout-grid" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.IMPORT_LAYOUTS' | translate }}</span>
              </span>
            </a>

            <!-- Painel (Dashboard planejado x realizado) - somente Admin -->
            <a mat-list-item class="menu-item"
              *ngIf="showPainel$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/painel')"
              (click)="irParaUrl(PAINEL_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="insert-chart" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="insert-chart" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.PAINEL' | translate }}</span>
              </span>
            </a>

            <!-- Relatório -->
            <a mat-list-item class="menu-item"
              *ngIf="showRelatorio$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/relatorio')"
              (click)="irParaUrl(RELATORIO_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="relatorio" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="relatorio" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.REPORT' | translate }}</span>
              </span>
            </a>

            <!-- Tipos de Despesas -->
            <a mat-list-item class="menu-item"
              *ngIf="showDespesas$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/despesas')"
              (click)="irParaUrl(TIPOS_DESPESAS_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="receipt" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon class="mr-5" svgIcon="receipt" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.DESPESAS' | translate }}</span>
              </span>
            </a>

            <!-- Integração -->
            <a mat-list-item class="menu-item"
              *ngIf="showIntegracaoMenu$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/integracao')"
              (click)="irParaUrl(INTEGRACAO_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="blocks" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon class="mr-5" svgIcon="blocks" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.INTEGRACAO' | translate }}</span>
              </span>
            </a>

            <!-- Tratativa -->
            <a mat-list-item class="menu-item"
              *ngIf="showTratativa$ | async"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/configuracoes/tratativa')"
              (click)="irParaUrl(TRATATIVA_PATH)">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="message-circle-warning" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon class="mr-5" svgIcon="message-circle-warning" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'CONFIG.SIDE_MENU.GENERAL.TRATATIVA' | translate }}</span>
              </span>
            </a>
          </div>

          <div class="menu-end">
            <a mat-list-item class="menu-item" *ngIf="hasLogoutRedirect" (click)="logoutRedirect()">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" *ngIf="(sidenavExpanse | async) === false">logout</mat-icon>
                <mat-icon class="mr-3" *ngIf="(sidenavExpanse | async)">logout</mat-icon>
                <span *ngIf="(sidenavExpanse | async)">Voltar ao Início</span>
              </span>
            </a>
          </div>
        </div>

      </mat-list>

    </ng-container>

    <!-- Botão Voltar ao Início (escondido para admins) -->
    <div class="frame-627965" *ngIf="(sidenavExpanse | async) && shouldShowBackButton" (click)="voltarAoInicio()">
      <div class="mds-button-menu">
        <div class="frame-627336">
          <svg class="undo-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.70711 3.29289C10.0976 3.68342 10.0976 4.31658 9.70711 4.70711L6.41421 8H14.5C15.3536 8 16.1988 8.16813 16.9874 8.49478C17.7761 8.82144 18.4926 9.30022 19.0962 9.90381C19.6998 10.5074 20.1786 11.2239 20.5052 12.0126C20.8319 12.8012 21 13.6464 21 14.5C21 15.3536 20.8319 16.1988 20.5052 16.9874C20.1786 17.7761 19.6998 18.4926 19.0962 19.0962C18.4926 19.6998 17.7761 20.1786 16.9874 20.5052C16.1988 20.8319 15.3536 21 14.5 21H11C10.4477 21 10 20.5523 10 20C10 19.4477 10.4477 19 11 19H14.5C15.0909 19 15.6761 18.8836 16.2221 18.6575C16.768 18.4313 17.2641 18.0998 17.682 17.682C18.0998 17.2641 18.4313 16.768 18.6575 16.2221C18.8836 15.6761 19 15.0909 19 14.5C19 13.9091 18.8836 13.3239 18.6575 12.7779C18.4313 12.232 18.0998 11.7359 17.682 11.318C17.2641 10.9002 16.768 10.5687 16.2221 10.3425C15.6761 10.1164 15.0909 10 14.5 10H6.41421L9.70711 13.2929C10.0976 13.6834 10.0976 14.3166 9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071L3.29289 9.70711C2.90237 9.31658 2.90237 8.68342 3.29289 8.29289L8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289Z" fill="#408afa" />
          </svg>
        </div>
      </div>
      <div class="voltar-ao-in-cio">Voltar ao Início</div>
    </div>

    <!-- Seção de Versão - FORA do ng-container para ficar no sidenav-base -->
    <div class="version">
      <!-- Versão fechada - só mostra o ícone -->
      <div *ngIf="(sidenavExpanse | async) === false" class="version-icon">
        <mat-icon svgIcon="infinito"></mat-icon>
      </div>

      <!-- Versão aberta - mostra informações completas -->
      <div *ngIf="(sidenavExpanse | async) === true" class="version-expanded">
        <div class="version-title">{{ descriptionState | async }}</div>
        <div class="version-row">
          <div class="version-brand">
            <span class="version-powered-by">POWERED BY</span>
            <span
              class="version-logo-img"
              role="img"
              aria-label="Mobiis"
              (click)="irParaUrl('/')"
              (keydown)="irParaUrl('/')"
              tabindex="0"
            ></span>
          </div>
          <span class="version-number">v {{ versaoState | async }}</span>
        </div>
      </div>
    </div>

  </div>
</div>
